import React from "react"

import {
	Box,
	Grid,
	Stack,
	Typography,
} from "@mui/material"

import { t } from "@lingui/macro"
import { UseFormReturn } from "react-hook-form"

import {
	MatesCheckbox,
	MatesMultiSelect,
	MatesTextField,
	withUseFormHook,
} from "@sinossi/mates-react-library"

import { AdvancedSearchbar } from "components/advanced-searchbar/advanced-searchbar"

import { PaginatedResponse } from "models/commons/paginated-response"
import { Product } from "models/product"
import { BrandManagementRequest } from "models/brand-management"

import BrandAdvancedSearchValidation, { BrandAdvancedSearchForm } from "./form"

interface BrandAdvancedSearchProps extends UseFormReturn
{
	products: PaginatedResponse<Product>
	handleCallback: (data: BrandManagementRequest) => void
}
class BrandAdvancedSearch extends React.Component<BrandAdvancedSearchProps, {}>
{
	private products: { [id: string]: string } = {}

	public componentDidMount()
	{
		this.products = Object.fromEntries(
			this.props.products.items
				.sort((a, b) => a.name.localeCompare(b.name))
				.map(x => [x.id, x.name])
		)

		const formData: BrandAdvancedSearchForm = new BrandAdvancedSearchForm()
		this.props.reset(formData)
	}

	private onSearch = (data: Record<string, any>): void => {
		const formData: BrandAdvancedSearchForm = new BrandAdvancedSearchForm()
		Object.assign(formData, data)

		const request: BrandManagementRequest = formData.toRequest()

		this.props.handleCallback(request)
	}

	private onContractsRangeChange = (data: boolean, fieldName: string): boolean => {
		if(fieldName === "contracts09") {
			this.props.setValue("contracts1099", null)
			this.props.setValue("contracts100999", null)
			this.props.setValue("contracts1000", null)
		} else if(fieldName === "contracts1099") {
			this.props.setValue("contracts09", null)
			this.props.setValue("contracts100999", null)
			this.props.setValue("contracts1000", null)
		} else if(fieldName === "contracts100999") {
			this.props.setValue("contracts09", null)
			this.props.setValue("contracts1099", null)
			this.props.setValue("contracts1000", null)
		} else if(fieldName === "contracts1000") {
			this.props.setValue("contracts09", null)
			this.props.setValue("contracts1099", null)
			this.props.setValue("contracts100999", null)
		}

		return data
	}

	render()
	{
		return (
			<AdvancedSearchbar
				{...this.props}
				searchFieldName="brand"
				searchFieldPlaceholder="Ricerca Brand"
				onSearch={this.onSearch}>
				<Grid container spacing={2}>
					<Grid item xs={12} md={6}>
						<Stack direction="column">
							<MatesTextField
								variant="outlined"
								label={t({
									id: "advanced-searchbar.company-name",
									message: "Nome società",
								})}
								name="company"
								control={this.props.control}
								trigger={this.props.trigger}
								formState={this.props.formState}
							/>
							<Box display="inline-block" sx={{ mt: 3, }}>
								<MatesMultiSelect
									name="products"
									label="Categorie merceologiche"
									variant="outlined"
									control={this.props.control}
									formState={this.props.formState}
									trigger={this.props.trigger}
									entries={this.products}
								/>
							</Box>
						</Stack>
					</Grid>
					<Grid item xs={12} md={3} textAlign="right" alignItems="center" justifyContent="center">
						<Typography sx={{ fontWeight: "bold" }}>Numero di aperture</Typography>
					</Grid>
					<Grid item xs={12} md={3}>
						<MatesCheckbox
							name="contracts09"
							label="0-9"
							control={this.props.control}
							formState={this.props.formState}
							trigger={this.props.trigger}
							onChange={(data: boolean) => this.onContractsRangeChange(data, "contracts09")} /> <br />
						<MatesCheckbox
							name="contracts1099"
							label="10-99"
							control={this.props.control}
							formState={this.props.formState}
							trigger={this.props.trigger}
							onChange={(data: boolean) => this.onContractsRangeChange(data, "contracts1099")} /> <br />
						<MatesCheckbox
							name="contracts100999"
							label="100-999"
							control={this.props.control}
							formState={this.props.formState}
							trigger={this.props.trigger}
							onChange={(data: boolean) => this.onContractsRangeChange(data, "contracts100999")} /> <br />
						<MatesCheckbox
							name="contracts1000"
							label="1000+"
							control={this.props.control}
							formState={this.props.formState}
							trigger={this.props.trigger}
							onChange={(data: boolean) => this.onContractsRangeChange(data, "contracts1000")} /> <br />
					</Grid>
				</Grid>
			</AdvancedSearchbar>
		)
	}
}

export default withUseFormHook<BrandAdvancedSearchForm>(
	BrandAdvancedSearch,
	BrandAdvancedSearchValidation,
	new BrandAdvancedSearchForm()
)
